/**
 * Default Client Configuration
 * Only includes settings that are actively used in the application
 */

import { PRICE_DISPLAY_MODES } from '../productPricing';

export const defaultConfig = {
  // Client identification
  clientId: 'default',
  clientName: 'Default Client',

  // Currency settings
  currency: {
    code: 'KM',
    symbol: 'KM',
    decimalPlaces: 2,
    thousandSeparator: '.',
    decimalSeparator: ',',
  },

  // First entry is the boot default; the rest are offered in the language menu.
  localization: {
    languages: ['bs'],
  },

  // Tax settings
  tax: {
    pdv: 17, // PDV percentage
    label: 'PDV',
  },

  productPricing: {
    defaultDisplayMode: PRICE_DISPLAY_MODES.STANDARD,
    orderAmountDecimals: 2,
    priceDisplayDecimals: 2,
    strategy: 'compound-discount',
    usePriceInquiry: false,
    retryPriceInquiry: false,
    showCartItemDiscountBreakdown: false,
    preserveTariffGroup: false,
    showRetailPriceTag: false,
    displayOnlyOutOfStockPrice: false,
    organizationOverrides: [],
  },

  productCatalog: {
    quantityKeyboardPosition: 'inline',
    highlightOrderRecency: false,
    filterOrder: [
      'category',
      'quantity',
      'favourites',
      'withoutRecentSales',
      'sort',
      'supplier',
      'customerCategory',
      'discount',
      'ulistan',
      'assortment',
    ],
    useUnrestrictedProductsQuery: false,
    includeSupplier: false,
    showQuantityFilter: true,
    showSupplierFilter: false,
    showDiscountFilter: true,
    showPdvToggle: true,
  },

  orderQuantity: {
    integerOnlyOrderTypeCodes: [],
    respectProductDecimalFlag: true,
  },

  orders: {
    defaultOrderType: {
      id: '10',
      code: '10',
      name: 'Narudžba',
      initialStatus: '2',
    },
    defaultStatus: '9',
    defaultPaymentOption: 'ZIR',
    koOrderTypeCode: 'KO',
    koDiscountClassId: '4489783',
    giftOrderTypeCode: '981',
    posOrderTypeCodes: ['20'],
    useGrossCartPrices: false,
    refreshPricesBeforeDownload: false,
    showLocalBackupActions: false,
    showDocumentTypeReport: false,
    showCartItemComments: false,
    showCartItemIdentifiers: false,
    showOrderAmountsInReport: false,
    approvalDocumentTypeCodes: ['12', '13', '15', '16'],
  },

  customers: {
    exitOnLogoClick: false,
    exitAfterCheckout: false,
    fetchDiscounts: false,
    routeLookupMode: 'own',
    allowExitWithoutAdminOnIncompleteWork: false,
    showOpenItemsTab: true,
    openItemsMode: 'standard',
  },

  tasks: {
    defaultCategoryId: '49',
    allowStatusActionsWithoutSuperior: false,
  },

  sync: {
    defaultExcludedOptions: [],
    allowDeleteWithoutAdmin: false,
  },

  dayLifecycle: {
    allowForceStartWithoutAdmin: false,
    compactFinishDayButton: false,
  },

  tobacco: {
    enabled: false,
    orderTypeCodes: ['11', '13', '16'],
    batProductGroupPrefixes: ['61', '62', '63'],
    tobaccoCategoryCode: '08',
  },

  surveys: {
    defaultCompletionSource: 'ataco',
  },

  monitoring: {
    networkDetailAllowUrls: ['localhost', '^https?://.*\\.infostudio\\.app'],
    tracePropagationTargets: ['localhost', '^https?://.*\\.infostudio\\.app'],
  },

  help: {
    ordersGuideUrl:
      'https://docs.google.com/document/d/1_4U_QGbYOEry1QegyF6qDbOht00ZkDVbayWePq5GZ2c/edit?usp=sharing',
  },

  // Feature flags
  features: {
    fieldPhotos: false,
    showPaymentOption: true, // Show payment option field in checkout
    showDeliveryDate: true, // Show delivery date field in checkout
    showDiscount: true, // Show discount (Diskont) checkbox in checkout
    showCustomerDebtInfo: false, // Show debt info on CustomerCard (totalDebt, dueDebt, inWeekDebt)
    useCustomerDebtSnapshot: false, // Use aggregated debt snapshot instead of open item summary
    allowBlockedCustomerApproval: false, // Allow blocked customer orders to be sent for approval
    showBlockedCustomerUnblockedSyncAlert: false, // Inform user when approval is no longer needed after customer unblock
    refreshSelectedCustomerAfterSync: false, // Keep selected customer current after incoming customer sync
  },
};

export default defaultConfig;
